module.exports = __webpack_public_path__ + "static/media/tata_trusts.529e652e.svg";